export class NgwGame {
    id:number
    nhlGame:any
    nhlId:number
    gameDate:Date
    away:any
    home:NgwTeam
    rounds:NgwRound[]
    players:NgwPlayer[]
    currScore?:NgwScore
    starred?:Boolean
}

export class NgwScore {
    status:string
    awayScore: number
    homeScore: number
    currentPeriod: number
    currentPeriodOrdinal: string
    currentPeriodTimeRemaining: string
    goals: number[]
                        
}

export class NgwTeam {
    id:number
    abbreviation:String
    teamName:String
    locationName:String
    team:any
}

export class NgwPlayer {
    name:String
    balance?:number
    selected?:Boolean
    removed?:Boolean
    deleted?:Boolean
}


export class NgwRound {
    num:number
    isScored:Boolean
    result?:String
    startingAwayScore:number
    startingHomeScore:number
    startingPot:number
    totalPot:number
    picks:NgwPick[]
    scoredPlayerPoints?:any[]
    carryOverToNextRoundPot:number
    goalScorer?:any
    winningPick?:NgwPick
    playerOrder:NgwPlayer[]
}

export class NgwPick {
    ngwPlayer:NgwPlayer
    nhlPlayer:any
    isScored:Boolean
    isWinner:Boolean
}


// WEBPACK FOOTER //
// ./src/app/classes/NgwGame.ts